import React from 'react';
import { Link } from 'react-router-dom';

export interface LogoProps {
  /** Where the logo links to. Defaults to the landing page. */
  to?: string;
  /** Mark only, no wordmark — used where header width is tight. */
  compact?: boolean;
}

/** Word/figure mark shared by the AppShell header and (later) the landing page. */
export const Logo: React.FC<LogoProps> = ({ to = '/', compact = false }) => (
  <Link
    to={to}
    aria-label={compact ? 'Schneller Wohnen, Startseite' : undefined}
    className="flex min-w-0 items-center gap-2 rounded-control text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-page"
  >
    {/* The original phone-with-house mark (also the Telegram bot avatar); logo-dark.svg is
        its light-stroke variant for dark mode. */}
    <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="" className="h-8 w-8 shrink-0 dark:hidden" />
    <img src={`${process.env.PUBLIC_URL}/logo-dark.svg`} alt="" className="hidden h-8 w-8 shrink-0 dark:block" />
    {!compact && <span className="truncate font-display font-semibold">Schneller Wohnen</span>}
  </Link>
);
